import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { IconNavSharedComponent } from './icon.nav.component';

import { IconSharedModule } from './../../atoms/entry';

@NgModule({
    declarations: [
        IconNavSharedComponent
    ],
    imports: [
        CommonModule,
        IconSharedModule,
        RouterModule.forChild([])
    ],
    exports: [
        IconNavSharedComponent
    ]
})

export class IconNavSharedModule {}
